import React from 'react';
import { connect } from 'react-redux';

import { ButtonBase, TextField, Typography } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';

import TrplSelect from '../../../../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../../../../common/TrplControls/TrplCheckbox';
import { getFormsSelectValues } from '../../../../../utils';

const OtherControls = ({
  jels,
  nodes,
  classes,
  settings,
  conceptId,
  hasNotValidRst,
  openFrmEditModal,
  changeFieldInMainTable,
  onUpdateTableSelectChange,
  onEditNodeFormSelectChange,
  removeNonExistingRestrictions,
}) => {
  const editNodeSelectValue =
    settings.buttons && settings.buttons.editNode && jels.jelData[settings.buttons.editNode]
      ? settings.buttons.editNode
      : 'none';

  const tableEditDisabled = editNodeSelectValue === 'none';

  const updateTableValues = [
    { title: 'Disabled', value: 'disabled' },
    { title: '10 sec', value: '10000' },
    { title: '20 sec', value: '20000' },
    { title: '1 min', value: '60000' },
  ];

  const frmsValues = getFormsSelectValues(jels, conceptId, nodes);

  return (
    <div className={`${classes.alignCenter} ${classes.spaceBetween} ${classes.mb20}`}>
      <div className={`${classes.alignCenter}`}>
        <TextField
          type="number"
          label="Rows to show"
          value={settings.rowsToShow}
          className={`${classes.mr10} ${classes.w200} ${classes.tableEditInput}`}
          onChange={(e) => changeFieldInMainTable('rowsToShow', +e.target.value)}
        />

        <div className={`${classes.alignEnd} ${classes.mr20}`}>
          <div className={classes.w200}>
            <TrplSelect
              margin="none"
              complicatedValues
              placeholder='Select on edit click form'
              firstChilds={
                <ButtonBase
                  style={{ textTransform: 'none' }}
                  onClick={() => {
                    openFrmEditModal(true);
                  }}
                  className={`${classes.btnGray} ${classes.mb5}`}
                >
                  Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                </ButtonBase>
              }
              values={frmsValues}
              value={editNodeSelectValue}
              title="On edit node click form"
              onChange={(e) => onEditNodeFormSelectChange(e)}
            />
          </div>

          <ButtonBase
            onClick={() => openFrmEditModal(editNodeSelectValue)}
            className={classes.ml10}
            disabled={tableEditDisabled}
            style={{
              opacity: `${tableEditDisabled ? '0.5' : ''}`,
            }}
          >
            <EditIcon className={classes.editFrmIcon} />
          </ButtonBase>
        </div>

        <div className={`${classes.w200} ${classes.mr10}`}>
          <TrplSelect
            margin="none"
            complicatedValues
            values={updateTableValues}
            title="Update table every"
            onChange={(e) => onUpdateTableSelectChange(e)}
            value={settings.update_table_period || 'disabled'}
          />
        </div>

        <TrplCheckbox
          className={classes.checkboxGray}
          label={<Typography style={{ fontSize: '12px', lineHeight: 1, width: '40px' }}>Show index</Typography>}
          checked={settings.show_index}
          onChange={(e) => changeFieldInMainTable('show_index', e.target.checked)}
        />

        <TrplCheckbox
          className={classes.checkboxGray}
          label={<Typography style={{ fontSize: '12px', lineHeight: 1, width: '40px' }}>Show node</Typography>}
          checked={settings.show_title}
          onChange={(e) => changeFieldInMainTable('show_title', e.target.checked)}
        />

        <TrplCheckbox
          className={classes.checkboxGray}
          label={<Typography style={{ fontSize: '12px', lineHeight: 1, width: '75px' }}>Show export btn</Typography>}
          checked={settings.show_export}
          onChange={(e) => changeFieldInMainTable('show_export', e.target.checked)}
        />

        <TrplCheckbox
          className={classes.checkboxGray}
          label={<Typography style={{ fontSize: '12px', lineHeight: 1, width: '75px' }}>Show create node btn</Typography>}
          checked={settings.show_create_node === undefined || settings.show_create_node}
          onChange={(e) => changeFieldInMainTable('show_create_node', e.target.checked)}
        />

        <TrplCheckbox
          className={classes.checkboxGray}
          label={<Typography style={{ fontSize: '12px', lineHeight: 1, width: '75px' }}>Bold rows divider</Typography>}
          checked={settings.bold_rows}
          onChange={(e) => changeFieldInMainTable('bold_rows', e.target.checked)}
        />
      </div>

      {hasNotValidRst ? (
        <ButtonBase
          onClick={removeNonExistingRestrictions}
          className={`${classes.btn} ${classes.secondaryBtn} ${classes.removeNotValidRstrsBtn}`}
        >
          <ClearIcon style={{ fontSize: '15px' }} />
          <span
            style={{
              lineHeight: '12px',
            }}
          >
            Remove all nonexistent predicates
          </span>
        </ButtonBase>
      ) : null}
    </div>
  );
};

export default connect((state) => {
  return { jels: state.jels };
})(OtherControls);
